import { t } from '@lingui/macro'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { SuggestionDataItem } from 'react-mentions'
import { Message } from '../../models/Message'
import { UtilApp } from '../../services/Utils/UtilApp'
import MentionTextArea from './MentionTextArea'

export const userMarkup = '[__display__](user:__id__)'

interface IMentionTextArea {
  className?: string;
  message: Message,
  suggestions: SuggestionDataItem[],
  onChange: (text: string) => void,
  onSubmit: ((text: string) => void)
}
const MessageTextArea: React.FC<IMentionTextArea> = memo(({ className, message, suggestions, onChange, onSubmit }) => {
  const [text, setText] = useState("");
  const [placeholder, setPlaceholder] = useState("")

  useEffect(() => {
    setText(message.text ?? "");
    if (message.replyTo) {
      setPlaceholder(t`Reply to ${message.replyTo.name}.`);
    } else {
      setPlaceholder(t`Mention with '@'` + (UtilApp.isMobileSize() ? '' : t`. Send with ctrl+enter.`))
    }
  }, [message.id, message.replyTo?.id]);

  const changed = useCallback((value: string) => {
    onChange(value);
    setText(value);
    message.text = value;
  }, [onChange, message]);

  return (<MentionTextArea className={className} text={text} placeholder={placeholder} suggestions={suggestions} onChange={changed} onSubmit={onSubmit} />);
});

export default MessageTextArea;
